import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { RoutesProvider } from "../contexts/RoutesContext";
import { DialogProvider } from "../contexts/DialogContext";
import { NasProvider } from "../contexts/NasContext";

export const RoutesComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <RoutesProvider key={0} />,
        <NasProvider key={1} />,
        <DialogProvider key={2} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
